import { ArrowPathIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { useContentActions } from "../../../hooks/ContentActionsContext";
import useUserDetails from "../../../hooks/useUserDetails";
import { SubmitButton } from "../buttons/submit-button";
import { UpdateImageModal } from "./update-image-modal";

export const ImageActionButtons = ({ src }: { src: string | null }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { remove } = useContentActions();
  const { userDetails } = useUserDetails();
  const isAdmin = userDetails?.type === "admin";

  if (!isAdmin) {
    return null;
    // return (
    // <div className="flex gap-2">
    //   <SubmitButton
    //     icon={<HandThumbUpIcon height={24} width={24} color="white" />}
    //     onClick={() => console.log("Thumbs up for image")}
    //     iconOnly={true}
    //   />
    //   <SubmitButton
    //     icon={<HandThumbDownIcon height={24} width={24} color="white" />}
    //     onClick={() => console.log("Thumbs down for image")}
    //     iconOnly={true}
    //   />
    // </div>
    // );
  }

  return (
    <div className="flex gap-2">
      <SubmitButton
        icon={<ArrowPathIcon height={24} width={24} color="white" />}
        onClick={async () => {
          setIsOpen(true);
        }}
        iconOnly={true}
      />
      <SubmitButton
        icon={<TrashIcon height={24} width={24} color="white" />}
        onClick={async () => {
          await remove(src ?? "");
        }}
        iconOnly={true}
      />
      <UpdateImageModal
        src={src ?? ""}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </div>
  );
};
